import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-pc-container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = {
  key: 0,
  class: "form-title"
}
const _hoisted_4 = {
  key: 1,
  class: "form-finish-title-right"
}
const _hoisted_5 = { class: "form-finish-title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  class: "variable-value-container"
}
const _hoisted_9 = {
  key: 0,
  class: "button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_LabelPC = _resolveComponent("LabelPC")!
  const _component_InputPC = _resolveComponent("InputPC")!
  const _component_RadioPC = _resolveComponent("RadioPC")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.checkTip())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.props.payload.content.tip), 1))
        : _createCommentVNode("", true),
      ($setup.props.payload.nodeStatus == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Icon, {
              src: $setup.iconSucess,
              style: {"margin":"0px 4px"}
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_5, _toDisplayString($setup.TUITranslateService.t("AIDesk.已提交")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.payload.content.inputVariables, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(_component_LabelPC, {
          name: item.name,
          "is-required": item.isRequired
        }, null, 8, ["name", "is-required"]),
        (item.formType == 0 && $setup.props.payload.nodeStatus !== 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_InputPC, {
                placeholder: item.placeholder,
                variableValue: item.variableValue,
                name: item.name,
                isRequired: item.isRequired,
                onInputChange: $setup.handleInputChange,
                validator: item.isRequired == 1 && $setup.isValid(item.name),
                isDisabled: $setup.props.payload.nodeStatus === 1
              }, null, 8, ["placeholder", "variableValue", "name", "isRequired", "onInputChange", "validator", "isDisabled"])
            ]))
          : (item.formType == 1 && $setup.props.payload.nodeStatus !== 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_RadioPC, {
                  chooseItemList: item.chooseItemList,
                  name: item.name,
                  isRequired: item.isRequired,
                  onInputChange: $setup.handleInputChange,
                  validator: item.isRequired == 1 && $setup.isValid(item.name),
                  isDisabled: $setup.props.payload.nodeStatus === 1
                }, null, 8, ["chooseItemList", "name", "isRequired", "onInputChange", "validator", "isDisabled"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.variableValue == '' ||  item.variableValue == null ? $setup.mapValue[item.name] : item.variableValue), 1))
      ]))
    }), 128)),
    ($setup.props.payload.nodeStatus !== 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass($setup.props.payload.nodeStatus === 1 ? 'button-disable' : 'button'),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleSendForm && $setup.handleSendForm(...args)))
          }, _toDisplayString($setup.TUITranslateService.t("AIDesk.提交")), 3)
        ]))
      : _createCommentVNode("", true)
  ]))
}